import { ChartingService } from "./../charting.service";
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
  TemplateRef,
} from "@angular/core";
import {
  Chart,
  ILegendClickEventArgs,
  ILoadedEventArgs,
  IMouseEventArgs,
  SeriesModel,
} from "@syncfusion/ej2-angular-charts";
import { LogService } from "src/app/services/log.service";
import { UtilsService } from "src/app/services/utils.service";
import { ITapChartConfig } from "../tap-chart.component";
import * as lodash from "lodash";

import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { BehaviorSubject, delay, of, take } from "rxjs";

@Component({
  selector: "app-tap-pop-out-chart",
  templateUrl: "./tap-pop-out-chart.component.html",
  styleUrls: ["./tap-pop-out-chart.component.css"],
})
export class TapPopOutChartComponent implements OnInit {
  @Input() chartLegend: TemplateRef<any>;
  @Input() chartTitle: string = "chart title here";
  @Input() popOutLegendPosition: string;
  @Output() chartLoaded = new EventEmitter();

  legendOrientation: string;
  isLoaded$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  onAxisRenderedCallback = ($event) => {};
  onPointRenderCallback = ($event) => {};
  onTooltipRenderCallback = ($event) => {};
  onLegendClickCallback = ($event) => {};
  private readonly dottedDashArray = "1, 2";
  private readonly chartTheme = "Material";
  private chartApi: Chart;
  private backgroundColor = "#ffffff00";
  private seriesFillColor =
    this.utilsService.getSiteWideThemeBackgroundColorHEXValue();

  showControls$ = new BehaviorSubject<boolean>(true);
  chartDefaultLegendDisplay = false;

  fontFamily = this.utilsService.getSiteWideThemeFontFamily();

  labelStyle = {
    fontFamily: this.fontFamily,
    fontWeight: "Bold",
  };

  _chartConfig: ITapChartConfig | null = null;

  get chartConfig() {
    return this._chartConfig;
  }

  @Input()
  set chartConfig(value: ITapChartConfig) {
    //inject  common series configuration into series config
    if (
      //value?.chartType !== "Pie" &&
      value?.chartSeries &&
      value?.chartSeries.length > 0
    ) {
      let chartConfigs = [];
      value.chartSeries.forEach((ct) => {
        chartConfigs.push(
          lodash.merge(lodash.cloneDeep(this.commonSeriesConfig), ct)
        );
      });
      value.chartSeries = chartConfigs;
    }

    this.chartTitle = value.chartTitle;

    // adjust chart height and width
    let chartHeight = "100%";
    let chartWidth = "";
    if (value?.chartType !== "Pie") {
      chartHeight = value?.chartHeight ?? "50%" ;
      chartWidth = "100%";
    }

    let displayLegendInChart = value?.displayLegend ?? false ;
    this.chartDefaultLegendDisplay = displayLegendInChart;
    let newLegendSettings = lodash.cloneDeep(value.legendSettings);
    newLegendSettings.visible = displayLegendInChart;
  
    this._chartConfig = lodash.merge(this._chartConfig, value, {
      chartTitle: null,
      chartHeight: chartHeight,
      chartWidth: chartWidth,
      legendSettings : newLegendSettings,
    });
    if (this._chartConfig.chartTheme.toLowerCase().includes("dark")) {
      this._chartConfig.backgroundColor =
        this.utilsService.getSiteWideThemeDarkColorHEXValue();
      this._chartConfig.chartArea.background =
        this.utilsService.getSiteWideThemeDarkColorHEXValue();
    }

    if (this.chartApi && this._chartData?.length) {
      this.refreshChartInternal();
    }
  }

  _chartData = [];
  get chartData() {
    return this._chartData;
  }
  @Input() set chartData(value) {
    this._chartData = value;

    if (!this.chartApi || !value?.length) return;
    this.refreshChartInternal();
  }

  subheaderVM?: {
    userName: string;
    profileName: string;
    orgName?: string;
    childOrgName?: string;
    regionName?: string;
    dateRange?: string;
  } = null;

  private commonSeriesConfig: SeriesModel = {
    animation: {
      enable: false, //disable animation on series selection
      duration: 50, //milliseconds of animation
      delay: 0,
    },
  };

  /* String Resource | Value Binding */
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      chartConfig: ITapChartConfig;
      chartData: any[];
      chartLegend: TemplateRef<any>;
      onAxisLabelRenderCallback: ($event: any) => void;
      onPointRenderCallback: ($event: any) => void;
      onTooltipRenderCallback: ($event: any) => void;
      popOutLegendPosition: string;
      onLegendClickCallback: ($event: any) => void;
    },
    private changeDetectorRef: ChangeDetectorRef,
    public dialogRef: MatDialogRef<TapPopOutChartComponent>,
    public utilsService: UtilsService,
    protected logger: LogService,
    private matDialog: MatDialog,
    private chartingService: ChartingService
  ) {
    if (!this.data) {
      return;
    }

    this.chartData = this.data.chartData;
    this.chartConfig = this.data.chartConfig;
    //this.chartConfig.chartSeries.forEach(cs => {
    //  if(cs?.cornerRadius){
    //    cs.cornerRadius.topLeft *= 2.5 ;
    //    cs.cornerRadius.topRight *= 2.5 ;
    //    cs.cornerRadius.bottomRight *= 2.5;
    //    cs.cornerRadius.bottomLeft *= 2.5;
    //  }
    //});
    this.chartLegend = this.data.chartLegend;
    this.onAxisRenderedCallback = this.data.onAxisLabelRenderCallback;
    this.onPointRenderCallback = this.data.onPointRenderCallback;
    this.onTooltipRenderCallback = this.data.onTooltipRenderCallback;
    this.popOutLegendPosition = this.data.popOutLegendPosition;
    this.onLegendClickCallback =  this.data.onLegendClickCallback;
  }

  async ngOnInit(): Promise<void> {
    this.subheaderVM = await this.chartingService.GetPopUpChartSubheaderModel();
    this.isLoaded$.next(true);
      // set up legend orientation
      if (this.popOutLegendPosition === 'bottom')
          this.legendOrientation = 'column';
      else
          this.legendOrientation = 'row';
  // no-op resize dispatch removed - rely on refresh helper instead

  }

  //Setup additional chart features.
  public chartLoad(args: ILoadedEventArgs): void {
    //chartLoad event can happen more than once (refreshes or updates to chart config trigger this)
    if (this.chartApi) return;

    this.chartApi = args.chart;

    //setup tooltip options. This is left to typescript code since we have two tooltip directives.
    // one is for Syncfusion charting to define congiguration and the other is to setup a tooltip pop-up material themed
    //component
    this.setupChartTooltip();

    if (this._chartData?.length) {
      this.refreshChartInternal();
    }
  }

  public pieChartLoad(args: ILoadedEventArgs): void {
    //todo:
    this.chartApi = args.chart;
    this.setupChartTooltip();

    if (this._chartData?.length) {
      this.refreshChartInternal();
    }
  }

  public onChartLoaded(args: any): void {
    this.chartLoaded.emit({ context: this, args });
  }

  public onChartClick(args: IMouseEventArgs) {
    //do nothing, stub code.
  }

  public onLegendClick($event) {
    this.onLegendClickCallback($event);
    this.logger.trackEvent(this._chartConfig.chartTitle, "legendClick");
  }

  public refreshChart(): void {
    this.refreshChartInternal();
  }

  private refreshChartInternal(): void {
    if (!this.chartApi) {
      return;
    }

    try {
      this.chartApi.refreshBound();
    } catch (error) {
      // no-op
    }

    try {
      this.chartApi.refresh();
    } catch (error) {
      // no-op
    }

    this.changeDetectorRef.detectChanges();
  }

  private setupChartTooltip() {
    this.chartApi.tooltip.enable = this.chartConfig.tooltip ?? true;
    this.chartApi.tooltip.textStyle = this.labelStyle;
  }

  onAxisLabelRender($event) {
    this.onAxisRenderedCallback($event);
  }

  

  onPointRender($event){
    this.onPointRenderCallback($event);
  }

  onTooltipRender($event) {
    this.onTooltipRenderCallback($event);
  }

  onCloseClick() {
    this.close();
  }

  onDownloadImageClick() {
    this.extractImageAndDownloadToClient();
  }


  close = () => {
    this.dialogRef.close();
  };

  extractImageAndDownloadToClient() {
    //hide the print button control or else it will be printed
    const element: HTMLElement = document.querySelector(
      ".chart-print-area"
    );
    this.showControls$.next(false);

    setTimeout(async () => {
      const html2canvas = (await import('html2canvas')).default;
      html2canvas(element)
        .then(function (canvas) {
          // Convert the canvas to blob
          canvas.toBlob(function (blob) {
            // To download directly on browser default 'downloads' location
            let link = document.createElement("a");
            link.download = "image.png";
            link.href = URL.createObjectURL(blob);
            link.click();
            // To save manually somewhere in file explorer
            //window.saveAs(blob, 'image.png');
          }, "image/png");
        })
        .finally(() => {
          this.showControls$.next(true);
        });
    }, 250);
  }
}
